import type { ComponentPropsWithoutRef } from "react";

export type SpaceListViewProps = ComponentPropsWithoutRef<"div">;

export const SpaceListView = ({ children, ...rest }: SpaceListViewProps) => (
  <div className="flex flex-col gap-y-1" {...rest}>
    {children}
  </div>
);
